import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service'
import { CommonService } from '../services/common.service';
@Injectable()
export class RoleGuard  {
  constructor(private commonService:CommonService,
    private router:Router){ }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      const expectedRoles : Array<number> = next.data.roles;
      const expectedWorkAreas: Array<string> = next.data.wa;
      let result = false;
      if ( !StorageService.isLogin()) {
        //
        this.commonService.changeHeader(false);
        this.router.navigate(['user/login'], { queryParams: { returnUrl: state.url }});
        result = false;
      }



      if (expectedRoles &&  expectedRoles.indexOf(StorageService.getRole()) > -1 ) {

        this.commonService.changeHeader(true);
        result = true;
      }
      if(expectedWorkAreas ) {

        const userWAs = StorageService.getWA();
        const filteredArray = expectedWorkAreas.filter(value => userWAs.includes(value));
        result =  (filteredArray.length > 0)
      }
      if(StorageService.getRole() == 10) {
        result = true;
      }


    if ( !result && StorageService.isLogin()) {
      alert('You are not authorized for this activity ' + state.url);
      //
    }
    return result;
  }
  canLoad(route: Route): boolean {
    let url: string = route.path;
    if (StorageService.isLogin()) {
	    return true;
    }
    // this.authService.setRedirectUrl(url);
    this.router.navigate(['user/login']);
    return false;
  }
}
